module.exports = {"backend":"https://cellarium.tiits.se","user":"bite","token":"7dfSmG10u60P!t9Xl@teKMxMc5#i5FHy"}


//////////////////
// WEBPACK FOOTER
// ./src/resources/settings/prod.json
// module id = nTml
// module chunks = 1